const CommonConfig = {
    colors: {},
    images: {
        Regular: {},
        Retina: {},
        Both: {}
    },
    resource: {GDP_COOKIE: "GPD_ACCEPTED"},
    fonts: {},
    messages: {
        "en": require("../locales/common/en")
    },
    styles: {
        MEDIA_QUERY_MOBILE: 800,
        MEDIA_QUERY_CARDS: 800,
        HEADER_ID: "header",
        FOOTER_ID: "footer"
    }
};

export default CommonConfig;
